import { awsImageRootUrl } from "lib/constants";
import { Business } from "lib/features/business/types";
import { Item } from "lib/features/item/types";
import { User } from "lib/features/user/types";

const getItemImageSource = (item: Item): string => {
  if (item?.item_type === 1 || item?.item_type === 3) {
    if (item?.itemImages?.length > 0) {
      const imageUri = item?.itemImages[0]?.uri;
      return imageUri.includes("cdn")
        ? imageUri
        : `${awsImageRootUrl}/${imageUri}`;
    }
  } else if (
    item.item_type === 4 &&
    item.farehabor_item_details?.image_cdn_url
  ) {
    return item.farehabor_item_details.image_cdn_url;
  }

  // Default fallback image
  return `${awsImageRootUrl}/imageNotFound.jpg`;
};

const getAvatarImageSource = (user: User): string => {
  return user?.avatar
    ? `${awsImageRootUrl}/${user.avatar}`
    : `${awsImageRootUrl}/imageNotFound.jpg`;
};


const getBusinessImageSource = (business: Business): string => {
  if (business?.businessImages?.[0]?.uri) {
    return `${awsImageRootUrl}/${business.businessImages[0].uri}`;
  } else if (business?.business_users?.[0]?.avatar) {
    return `${awsImageRootUrl}/${business.business_users[0].avatar}`;
  }

  return `${awsImageRootUrl}/imageNotFound.jpg`;
};

const getFullImageSource = (uri: string): string => {
  return `${awsImageRootUrl}/${uri}`;
}

export { getAvatarImageSource, getBusinessImageSource, getFullImageSource, getItemImageSource };

